/** The part of a rectangle `getBoundingClientRect` gives that the mapping needs. */
export interface SketchRect {
  left: number;
  top: number;
  width: number;
  height: number;
}

/**
 * Where a pointer is, in metres from the sketch's middle (north is +y): the sketch is a square whose side is
 * `2 * extent` metres. Null when the sketch has no size (not laid out).
 */
export function toMetres(
  clientX: number,
  clientY: number,
  rect: SketchRect,
  extent: number,
): { x: number; y: number } | null {
  if (!(rect.width > 0) || !(rect.height > 0)) return null;
  const x = ((clientX - rect.left) / rect.width - 0.5) * 2 * extent;
  const y = -((clientY - rect.top) / rect.height - 0.5) * 2 * extent;
  return { x, y };
}
